import { useMemo } from 'react';

import { useBreakPoints } from 'core';
import { ICredential, useListUserCreditCards } from 'core/Api';
import { ExistingCreditCard } from 'core/Components';
import { SimpleGrid } from 'ui';

import {
  CredentialCardModalProvider,
  useCredentialCardModalProvider,
} from './CredentialCardModalFactory';
import { CredentialCardModalWrapper } from './CredentialCardModalWrapper';
import { RemoveCredentialModalWrapper } from './RemoveCredentialModalWrapper';

type Props = {
  credential: ICredential;
};
const SwipeableCredentialCard = ({ credential }: Props) => {
  const { openModalById } = useCredentialCardModalProvider({});

  return (
    <ExistingCreditCard.Swipeable
      credential={credential}
      onClick={() => openModalById('Detail')}
      onAction={() => openModalById('Remove')}
    />
  );
};

const SwipeableCredentialCardWrapper = ({ credential }: Props) => {
  return (
    <CredentialCardModalProvider meta={{}}>
      <SwipeableCredentialCard credential={credential} />
      <CredentialCardModalWrapper credentialId={credential.uuid} />
      <RemoveCredentialModalWrapper credentialId={credential.uuid} />
    </CredentialCardModalProvider>
  );
};

type CredentialCardListProps = {
  isSingleColumn?: boolean;
};

const CredentialCardList = ({ isSingleColumn = false }: CredentialCardListProps) => {
  const { isSmallScreen } = useBreakPoints();
  const { data: credentials } = useListUserCreditCards();

  const cols = useMemo(() => {
    return isSingleColumn || isSmallScreen ? 1 : 2;
  }, [isSingleColumn, isSmallScreen]);

  return (
    <SimpleGrid cols={cols}>
      {credentials?.map((credential) => (
        <SwipeableCredentialCardWrapper credential={credential} key={credential.uuid} />
      ))}
    </SimpleGrid>
  );
};

export { CredentialCardList };
